import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights } from '../../defaultTheme';
const H4 = styled.h4 `
  font-size: ${fontSizes.large}px;
  line-height: ${lineHeights.root};
  font-weight: ${({ weight }) => fontWeights[weight || 'regular']};
  margin: 0;

  &:focus {
    outline: none;
  }
`;
export default H4;
